export default __webpack_public_path__ + "locales/pl/Files.json?hash=72dcba6b42c9b4c3423ac46622d7dc6d";